module.exports = __webpack_public_path__ + "img/cooperate_28.b31c99f2.svg";